import React from "react"
import { NavLink } from "react-router-dom"

const CustomBreadcrumb = ({ breadcrumbItems }) => {
  return (
    <nav aria-label='breadcrumb'>
      <ol className='custom-breadcrumb'>
        {breadcrumbItems.map((item, index) => (
          <li
            key={index}
            className={`custom-breadcrumb-item ${
              index === breadcrumbItems.length - 1 ? "active" : ""
            }`}
          >
            {index === breadcrumbItems.length - 1 ? (
              item.label
            ) : (
              <NavLink to={item.path} end>
                {item.label}
              </NavLink>
            )}
          </li>
        ))}
      </ol>
    </nav>
  )
}

export default CustomBreadcrumb
